import { initDefaultSelect2 } from '../../general/functions';
import { BASE_URL } from '../../general/variables';

const listenerCityMapping = () => {
  const $selectOne = $('#select2CityMappingOne'),
    $selectTwo = $('#select2CityMappingTwo');

  let isManualChange = false;

  const resetSelect = ($el) => {
    if ($el.hasClass('select2-hidden-accessible')) {
      $el.select2('destroy');
    }
    $el.val(null).empty();
  };

  // let flag = false;

  $(document).on('change', 'input[name="radioCityMap"]', function (e) {
    e.preventDefault();

    if (isManualChange) {
      // RESET BOTH (only when switching)
      resetSelect($selectOne);
      resetSelect($selectTwo);
    }

    let val = $(this).val();
    if (val == 'TEMPLATE') {
      $('#wrapperTemplate').removeClass('d-none');
      $('#wrapperCustom').addClass('d-none');

      initDefaultSelect2(
        true,
        {
          endpoint: `${BASE_URL}select2Controller/getCitiesTemplate`,
        },
        '#select2CityMappingOne',
        undefined,
        $selectOne.attr('data-placeholder'),
        false,
        true
      );
    }

    if (val == 'CUSTOM') {
      $('#wrapperTemplate').addClass('d-none');
      $('#wrapperCustom').removeClass('d-none');

      initDefaultSelect2(
        true,
        {
          endpoint: `${BASE_URL}select2Controller/getCitiesCustom`,
          is_group: true,
        },
        '#select2CityMappingTwo',
        undefined,
        $selectTwo.attr('data-placeholder'),
        true,
        true,
        true,
        Infinity,
        true,
        null,
        null,
        null,
        null,
        false
      );
    }

    isManualChange = true;
  });

  $('input[name="radioCityMap"]').filter(':checked').change();
};

export { listenerCityMapping };
